import {Component, isDevMode, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {environment} from "../../../../../environments/environment";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {MatSelectChange} from "@angular/material/select";
import * as XLSX from "xlsx";
import {Centre} from "../../../../interfaces/Centres";
import {CentreService} from "../../../../services/centre.service";
import {PermissionType} from "../../../../components/employee/PermissionType.enum";
import {FinancialYearService} from "../../../../services/financial-year.service";

@Component({
  selector: 'app-gender-count-report',
  templateUrl: './gender-count-report.component.html',
  styleUrls: ['./gender-count-report.component.scss']
})
export class GenderCountReportComponent implements OnInit, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  private _destroyed$ = new Subject<void>();
  dataSource = new MatTableDataSource<any>();
  dataSource2 = new MatTableDataSource<any>();
  fileName = 'Gender_Count_Report.xlsx';

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatPaginator) paginator2!: MatPaginator;
  centres$: Observable<Centre[]>;

  // selectedCentre:any;
  // selectedCentreCode: any = 'All'


  selectedCentre: Centre[] = [];
  selectedCentreCode: string[] = []; // MULTI + ALL support

  displayCentre = (c: any) => c?.centreName;

  isLoading = false;  // New loading flag
  startDate: Date | null = null
  endDate: Date | null = null
  displayedColumns: string[] = ['centreName', 'maleCount', 'femaleCount'];
  displayedColumns2: string[] = ['centreName', 'maleCount', 'femaleCount'];
  tmcount=0
  tfcount=0
  tfmcount=0
  tffcount =0
  constructor(private mFirestore: AngularFirestore,
              private mCentreService: CentreService,
              private readonly financialYearService: FinancialYearService) {
    this.centres$ = this.mCentreService.getAllCentres();

  }

  ngOnInit(): void {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;
    // this.mFirestore.collection(this.env.child).valueChanges().subscribe((children: any[]) => {
    //
    //   const groupedByCentre = children.reduce((acc, child) => {
    //     const centreName = child.centreName;
    //     acc[centreName] = acc[centreName] || { maleCount: 0, femaleCount: 0 };
    //
    //     // Check gender and increment count
    //     if (child.gender.toLowerCase() === 'male') {
    //       acc[centreName].maleCount++;
    //     } else if (child.gender.toLowerCase() === 'female') {
    //       acc[centreName].femaleCount++;
    //     }
    //
    //     return acc;
    //   }, {});
    //
    //   this.dataSource.data = Object.keys(groupedByCentre).map(centreName => ({
    //     centreName,
    //     maleCount: groupedByCentre[centreName].maleCount,
    //     femaleCount: groupedByCentre[centreName].femaleCount
    //   }));
    //   console.log(this.dataSource.data)
    //
    //   this.dataSource.paginator = this.paginator;
    // });

  }

  // onCentreSelect(selectedCentre: Centre) {
  //   if (!selectedCentre) return;
  //
  //   console.log("Selected Centre:", selectedCentre);
  //
  //   this.selectedCentre = selectedCentre;
  //
  //   this.selectedCentreCode=selectedCentre.centreCode;
  //
  //
  //
  //   // // 1️⃣ Set centre details in form
  //   // this.studentForm.patchValue({
  //   //   centreName: selectedCentre.centreName,
  //   //   centreCode: selectedCentre.centreCode
  //   // });
  // }


  onCentreSelect(selectedCentre: Centre | Centre[]) {

    if (!selectedCentre || (Array.isArray(selectedCentre) && selectedCentre.length === 0)) {
      // ALL centres
      this.selectedCentre = [];
      this.selectedCentreCode = [];
      return;
    }


    const centres = Array.isArray(selectedCentre) ? selectedCentre : [selectedCentre];

    this.selectedCentre = centres;
    this.selectedCentreCode = centres.map(c => c.centreCode);

    console.log('Selected Centres:', this.selectedCentreCode);
  }


  search() {
    //all null
    console.log(this.startDate)
    console.log(this.endDate)
    console.log(this.selectedCentreCode)
    // When dates are null and selected CentreCode ==null
    if (this.startDate == null && this.endDate == null && this.selectedCentreCode.length > 0) {
      console.log('in 1')
      alert('in 1')
      this.mFirestore.collection(this.env.child).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((children: any[]) => {

        const groupedByCentre = children.reduce((acc, child) => {
          const centreName = child.centreName;
          acc[centreName] = acc[centreName] || {maleCount: 0, femaleCount: 0};

          // Check gender and increment count
          if (child.gender.toLowerCase() === 'male') {
            acc[centreName].maleCount++;
          } else if (child.gender.toLowerCase() === 'female') {
            acc[centreName].femaleCount++;
          }

          return acc;
        }, {});

        this.dataSource.data = Object.keys(groupedByCentre).map(centreName => ({
          centreName,
          maleCount: groupedByCentre[centreName].maleCount,
          femaleCount: groupedByCentre[centreName].femaleCount
        }));
        console.log(this.dataSource.data)

        this.dataSource.paginator = this.paginator;
      });

    }
    //where only centre selected
    else if (this.startDate == null && this.endDate == null && this.selectedCentreCode.length>0) {
      console.log('in 2')
      alert('in 2')
      this.mFirestore.collection(this.env.child, ref => ref
        .where('centreCode', '==', this.selectedCentreCode)
      )


        .valueChanges()
        .pipe(takeUntil(this._destroyed$))
        .subscribe((children: any[]) => {

          const groupedByCentre = children.reduce((acc, child) => {
            const centreName = child.centreName;
            acc[centreName] = acc[centreName] || {maleCount: 0, femaleCount: 0};

            // Check gender and increment count
            if (child.gender.toLowerCase() == 'male') {
              acc[centreName].maleCount++;
            } else if (child.gender.toLowerCase() == 'female') {
              acc[centreName].femaleCount++;
            }

            return acc;
          }, {});

          this.dataSource.data = Object.keys(groupedByCentre).map(centreName => ({
            centreName,
            maleCount: groupedByCentre[centreName].maleCount,
            femaleCount: groupedByCentre[centreName].femaleCount
          }));
          console.log(this.dataSource.data)

          this.dataSource.paginator = this.paginator;
        });
    }
    //dates and centre is not null
    else if (this.startDate != null && this.endDate != null && this.selectedCentreCode.length>0) {
      console.log('in 3')
      this.mFirestore.collection(this.env.child, ref => ref

        .where('dateOfAdmission', '>=', this.startDate)
        .where('dateOfAdmission', '<=', this.endDate)
      ).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((children: any[]) => {
        alert(children.length)
        const groupedByCentre = children.reduce((acc, child) => {
          const centreName = child.centreName;
          acc[centreName] = acc[centreName] || {maleCount: 0, femaleCount: 0};

          // Check gender and increment count
          if (child.gender.toLowerCase() == 'male') {
            acc[centreName].maleCount++;
          } else if (child.gender.toLowerCase() == 'female') {
            acc[centreName].femaleCount++;
          }

          return acc;
        }, {});

        this.dataSource.data = Object.keys(groupedByCentre).map(centreName => ({
          centreName,
          maleCount: groupedByCentre[centreName].maleCount,
          femaleCount: groupedByCentre[centreName].femaleCount
        }));

        console.log(this.dataSource.data)

        this.dataSource.paginator = this.paginator;
      });
    } else if (this.startDate != null && this.endDate != null && this.selectedCentreCode.length>0) {
      console.log('in 4')
      this.mFirestore.collection(this.env.child, ref => ref.where('centreCode', '==', this.selectedCentreCode)
        .where('dateOfAdmission', '>=', this.startDate)
        .where('dateOfAdmission', '<=', this.endDate)
      ).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((children: any[]) => {

        const groupedByCentre = children.reduce((acc, child) => {
          const centreName = child.centreName;
          acc[centreName] = acc[centreName] || {maleCount: 0, femaleCount: 0};

          // Check gender and increment count
          if (child.gender.toLowerCase() === 'male') {
            acc[centreName].maleCount++;
          } else if (child.gender.toLowerCase() === 'female') {
            acc[centreName].femaleCount++;
          }

          return acc;
        }, {});

        this.dataSource.data = Object.keys(groupedByCentre).map(centreName => ({
          centreName,
          maleCount: groupedByCentre[centreName].maleCount,
          femaleCount: groupedByCentre[centreName].femaleCount
        }));
        console.log(this.dataSource.data)

        this.dataSource.paginator = this.paginator;
      });
    }

  }

  search2() {
    //all null
    //all null
    this.isLoading = true;  // Start loading
    console.log(`Start Date :${this.startDate} `)
    console.log(`End Date :${this.endDate}`)
    console.log(`Selected Centre Code : ${this.selectedCentreCode}`)


    this.mFirestore.collection(this.env.child,ref => ref.orderBy('centreCode')).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((children: any[]) => {
      let d: any[] = []
      d = children
      if (this.selectedCentreCode.length > 0) {
        d = children.filter(x => this.selectedCentreCode.includes(x.centreCode));
      }


      // if (this.startDate != null && this.endDate != null) {
      //     d = d.filter((x) => x.dateOfAdmission.toDate() >= this.startDate!! && x.dateOfAdmission.toDate() <= this.endDate!!)
      // let cc:string[] =[]
      //     d.forEach(c=>{
      //    cc.push( c.centreName)
      // })
      //     console.log('CC',cc)
      //
      // }
      let ccc: any[] = []
      if(this.startDate && this.endDate)    d.forEach(child => {
        child.admissionData.forEach((ad: any, i: number) => {
          try {
            if (i % 2 == 0 && ad.dateOfAdmission?.toDate() >= this.startDate!! && ad.dateOfAdmission?.toDate() <= this.endDate!!) {
              ccc.push(child)

            }
          }catch (e:any){
            console.log('Error occured in ',child.childCode +"Admission Data Index "+ i)
          }

        })
      })
      else ccc=d
      const groupedByCentre = ccc.reduce((acc, child) => {
        const centreName = child.centreName;
        acc[centreName] = acc[centreName] || {maleCount: 0, femaleCount: 0, fMaleCount: 0, fFemaleCount: 0,
        };

        // Check gender and increment count
        if (child.gender.toLowerCase() === 'male') {
          // acc[centreName].maleCount++;
          (child.admissionData.length > 2) ? acc[centreName].fMaleCount++ : acc[centreName].maleCount++

        } else if (child.gender.toLowerCase() === 'female') {
          // acc[centreName].femaleCount++;
          (child.admissionData.length > 2) ? acc[centreName].fFemaleCount++ : acc[centreName].femaleCount++
        }
        return acc;
      }, {});

      this.dataSource.data = Object.keys(groupedByCentre).map(centreName => ({
        centreName,
        maleCount: groupedByCentre[centreName].maleCount,
        femaleCount: groupedByCentre[centreName].femaleCount,
        fMaleCount: groupedByCentre[centreName].fMaleCount,
        fFemaleCount: groupedByCentre[centreName].fFemaleCount,

      }));
      this.dataSource2.data = Object.keys(groupedByCentre).map(centreName => ({
        centreName,
        maleCount: groupedByCentre[centreName].maleCount,
        femaleCount: groupedByCentre[centreName].femaleCount,
        fMaleCount: groupedByCentre[centreName].fMaleCount,
        fFemaleCount: groupedByCentre[centreName].fFemaleCount,

      }));
      // Calculate total counts, assuming properties `maleCount` and `femaleCount` exist
      this.tmcount = this.dataSource.data.reduce((acc, curr) => acc + curr.maleCount, 0);
      this.tfcount = this.dataSource.data.reduce((acc, curr) => acc + curr.femaleCount, 0);
      this.tffcount = this.dataSource.data.reduce((acc, curr) => acc + curr.fFemaleCount, 0);
      this.tfmcount= this.dataSource.data.reduce((acc, curr) => acc + curr.fMaleCount, 0);
      this.isLoading = false;  // Start loading
      // Update data source with total row
//       this.dataSource.data = [...this.dataSource.data, {
//   centreName: 'Total', maleCount: totalMaleCount || 0, femaleCount: totalFemaleCount || 0,
//         fFemaleCount: totalfFemaleCount || 0,
//         fMaleCount: totalfMaleCount || 0
//
// }]
      console.log(this.dataSource.data)
      this.dataSource.paginator = this.paginator;
      this.dataSource2.paginator = this.paginator2;
    });
    // this.isLoading = false;  // Start loading

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  OnCentreChange($event: MatSelectChange) {
    // this.mFirestore.collection(this.env.child).valueChanges().subscribe((children: any[]) => {
    this.selectedCentreCode = $event.value

    // const filterData = children.filter(child => child.centreCode == slectedCenter )
    //     const groupedByCentre = filterData.reduce((acc, child) => {
    //       const centreName = child.centreName;
    //       acc[centreName] = acc[centreName] || { maleCount: 0, femaleCount: 0 };
    //
    //       // Check gender and increment count
    //       if (child.gender.toLowerCase() === 'male') {
    //         acc[centreName].maleCount++;
    //       } else if (child.gender.toLowerCase() === 'female') {
    //         acc[centreName].femaleCount++;
    //       }
    //
    //       return acc;
    //     }, {});
    //
    //     this.dataSource.data = Object.keys(groupedByCentre).map(centreName => ({
    //       centreName,
    //       maleCount: groupedByCentre[centreName].maleCount,
    //       femaleCount: groupedByCentre[centreName].femaleCount
    //     }));
    //     console.log(this.dataSource.data)
    //
    //     this.dataSource.paginator = this.paginator;
    //   });

  }

  exportexcel() {

    /* assessment-table id is passed over here */
    let element = document.getElementById('excel-table');

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    // const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
    // const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet(this.receipts)
    ws['!cols'] = [];
    ws['!cols'][19] = {hidden: true};

    /* O1 is your Column in Excel*/

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);


  }
  exportexcel2() {

    /* assessment-table id is passed over here */
    let element = document.getElementById('excel-table2');

    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    // const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
    // const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet(this.receipts)
    ws['!cols'] = [];
    ws['!cols'][19] = {hidden: true};

    /* O1 is your Column in Excel*/

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);


  }


  // Clear() {
  //   this.dataSource.data = []
  //   this.selectedCentre=[]
  //   this.selectedCentreCode = 'All'
  //   this.endDate = null
  //   this.startDate = null
  // }

  Clear() {
    this.dataSource.data = [];
    this.dataSource2.data = [];

    this.selectedCentreCode = []
    this.selectedCentre=[]

    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;

    this.tmcount = 0;
    this.tfcount = 0;
    this.tfmcount = 0;
    this.tffcount = 0;
  }



  getTotal(a:number,b:number){
    return a+b
  }
  onEndDateChanged() {
    this.endDate?.setHours(23, 59, 0, 0);
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  protected readonly PermissionType = PermissionType;

}
